import { render, staticRenderFns } from "./TradeTicks.vue?vue&type=template&id=cf2bc0ce&scoped=true"
import script from "./TradeTicks.vue?vue&type=script&lang=js"
export * from "./TradeTicks.vue?vue&type=script&lang=js"
import style0 from "./TradeTicks.vue?vue&type=style&index=0&id=cf2bc0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2bc0ce",
  null
  
)

export default component.exports